import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getTripsNumberByDriverId } from '../../services/TripsService';
import { TripsNumberResponse } from '../../types/Trips';

function useGetTripsNumberByDriverId(fleetId: string, driverId: string): UseQueryResult<TripsNumberResponse> {
  return useQuery(
    ['trips-aggregation-count', fleetId, driverId],
    async (): Promise<TripsNumberResponse> => getTripsNumberByDriverId(fleetId, driverId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export default useGetTripsNumberByDriverId;
